var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6677 4.67163H6.06535C4.85565 4.67163 3.875 5.61749 3.875 6.78426V24.3895C3.875 25.5563 4.85565 26.5021 6.06535 26.5021H20.6677C21.8774 26.5021 22.8581 25.5563 22.8581 24.3895V6.78426C22.8581 5.61749 21.8774 4.67163 20.6677 4.67163Z",
    stroke: "#8E909E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1123 4.67163V6.09536C18.1123 6.48851 17.9795 6.84444 17.7648 7.10209C17.55 7.35973 17.2534 7.51909 16.9258 7.51909H9.80717C9.47954 7.51909 9.18293 7.35973 8.96823 7.10209C8.75352 6.84444 8.62073 6.48851 8.62073 6.09536V4.67163H18.1123Z",
    fill: "#8E909E",
    fillOpacity: 0.2,
    stroke: "#8E909E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5021 4.43433V3.36653C15.5021 2.67851 15.2232 2.05563 14.7723 1.60476C14.3215 1.15388 13.6986 0.875004 13.0106 0.875004C12.3226 0.875004 11.6997 1.15388 11.2488 1.60476C10.7979 2.05563 10.519 2.67851 10.519 3.36653V4.43433H15.5021Z",
    stroke: "#8E909E",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4151 10.3666L27.6038 14.3943V27.4513C27.6038 27.8445 27.4444 28.2004 27.1868 28.4581C26.9291 28.7157 26.5732 28.8751 26.1801 28.8751H11.9428C11.5496 28.8751 11.1937 28.7157 10.936 28.4581C10.6784 28.2004 10.519 27.8445 10.519 27.4513V11.7903C10.519 11.3972 10.6784 11.0412 10.936 10.7836C11.1937 10.5259 11.5496 10.3666 11.9428 10.3666H23.4151Z",
    fill: "white",
    stroke: "#8E909E",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3326 10.3666V14.6378C23.3326 15.0309 23.6514 15.3496 24.0445 15.3496H27.6038V14.2313L23.9478 10.3666H23.3326Z",
    fill: "#8E909E",
    fillOpacity: 0.2,
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7013 19.9767H23.4216",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7013 15.7056H19.0615",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7013 24.2479H23.4216",
    stroke: "#8E909E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.f2e823f63cbcdf95d6aae8d871774bb6.svg";
export { ForwardRef as ReactComponent };